/**
 * AdminGuard — Redirects non-admin users to /
 */

import { Navigate } from 'react-router-dom';
import { useUserRole } from '../../hooks/useUserRole';
import { Spinner } from '../ui';

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const { role, isLoading } = useUserRole();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted">
        <Spinner size="lg" />
      </div>
    );
  }

  if (role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
